import { z } from 'zod';
import Decimal from 'decimal.js';
import { slugRegex } from '../projects/admin-project-validation';

const MAX_DECIMAL_24_6 = new Decimal('999999999999999999.999999');
const MAX_SIGNED_INT = 2_147_483_647;

export const impactShopIdSchema = z.number().int().positive().max(MAX_SIGNED_INT);
export const impactShopSlugSchema = z.string().trim().min(1).max(191).regex(slugRegex, 'Slug must be kebab-case');

export const positiveDecimalSchema = z
  .number()
  .positive()
  .finite()
  .refine(value => new Decimal(value).lessThanOrEqualTo(MAX_DECIMAL_24_6), 'Must fit within the supported price range')
  .refine(value => new Decimal(value).decimalPlaces() <= 6, 'Must have no more than 6 decimal places');
export const impactShopCurrencyPricesSchema = z
  .object({
    GBP: positiveDecimalSchema,
    USD: positiveDecimalSchema,
    EUR: positiveDecimalSchema,
    CAD: positiveDecimalSchema,
    AUD: positiveDecimalSchema,
  })
  .strict();

export type ImpactShopReadinessIssueCode =
  | 'MISSING_TARGET'
  | 'MULTIPLE_TARGETS'
  | 'TARGET_NOT_AVAILABLE'
  | 'PROJECT_IMAGE_REQUIRED'
  | 'COMMERCIALS_REQUIRED'
  | 'COMMERCIALS_INVALID'
  | 'FUND_CONTENT_REQUIRED'
  | 'FUND_SHORT_DESCRIPTION_REQUIRED'
  | 'FUND_IMPACT_TYPE_REQUIRED'
  | 'FUND_IMAGE_REQUIRED'
  | 'FUND_ALLOCATIONS_REQUIRED'
  | 'FUND_ALLOCATION_PERCENTAGE_INVALID'
  | 'FUND_ALLOCATION_TOTAL_INVALID'
  | 'FUND_ALLOCATION_PRICES_INVALID'
  | 'FUND_ALLOCATION_PROJECT_PRICES_REQUIRED'
  | 'FUND_ALLOCATION_PROJECT_NOT_LIVE'
  | 'FUND_ALLOCATION_IMPACT_TYPE_INVALID';

export type ImpactShopReadinessIssue = {
  code: ImpactShopReadinessIssueCode;
  path: string[];
  message: string;
};

export type ImpactShopReadiness = {
  isReady: boolean;
  issues: ImpactShopReadinessIssue[];
};
